import React from "react";
import { Box } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";
import { dt } from "../../themes/redesignTokens";

// ═══════════════════════════════════════════════════════════════
//  MIDAS Design Tokens (local subset)
// ═══════════════════════════════════════════════════════════════


// ═══════════════════════════════════════════════════════════════
//  ChatDaySeparator
// ═══════════════════════════════════════════════════════════════

interface ChatDaySeparatorProps {
  date: string; // ISO timestamp
}

const ChatDaySeparator: React.FC<ChatDaySeparatorProps> = ({ date }) => {
  const { translate, i18n } = useTranslation("chatBot");

  const getLabel = (): string => {
    const msgDate = new Date(date);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const isSameDay = (a: Date, b: Date) =>
      a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();

    if (isSameDay(msgDate, today)) return translate("today");
    if (isSameDay(msgDate, yesterday)) return translate("yesterday");

    // Month name in the active UI language, not the browser's.
    return msgDate.toLocaleDateString(i18n.language, {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        my: "8px",
      }}
    >
      <Box
        sx={{
          fontFamily: dt.font,
          fontSize: "11px",
          fontWeight: 600,
          color: dt.textMuted,
          backgroundColor: dt.pageBg,
          padding: "4px 12px",
          borderRadius: "10px",
          border: `1px solid ${dt.cardBorder}`,
          userSelect: "none",
        }}
      >
        {getLabel()}
      </Box>
    </Box>
  );
};

export default ChatDaySeparator;
